import CalculationRouter from './CalculationRouter';
import ProjectSelectContainer from './calculator/project/ProjectSelectContainer';
import ConstructionSelectContainer from './calculator/construction/ConstructionSelectContainer';
import ConstructionContainer from './calculator/construction/ConstructionContainer';
import DemandContactSelectContainer from './demand/DemandContactSelectContainer';
import DemandInformationContainer from './demand/DemandInformationContainer';
import DemandInformationWorkIncludedContainer from './demand/DemandInformationWorkIncludedContainer';
import DemandThank from './demand/DemandThank';
import DemandWorkIncludedThank from "./demand/DemandWorkIncludedThank";

export default {
    path: '/kalkulacka',
    component: CalculationRouter,
    children: [
        {
            path: 'poptavka/odeslano',
            name: 'calculation.sent',
            component: DemandThank,
            meta: {title: 'Poptávka materiálu - odesláno'},
        },
        {
            path: 'poptavka/vcetne-prace-odeslano',
            name: 'calculation.sentWorkIncluded',
            component: DemandWorkIncludedThank,
            meta: {title: 'Poptávka materiálu - odesláno'},
        },
        {
            path: 'poptavka/kontaktni-udaje',
            name: 'calculation.demandInfomration',
            component: DemandInformationContainer,
            meta: {title: 'Poptávka materiálu - kontaktní informace'},
        },
        {
            path: 'poptavka/kontaktni-udaje-vcetne-prace',
            name: 'calculation.demandInformationIncludingWork',
            component: DemandInformationWorkIncludedContainer,
            meta: {title: 'Poptávka materiálu - kontaktní informace'},
        },
        {
            path: 'poptavka/vyber-dodavatele',
            name: 'calculation.contactSelect',
            component: DemandContactSelectContainer,
            meta: {title: 'Poptávka materiálu - výběr dodavatele'},
            children: [
                {
                    path: 'vyhledat',
                    name: 'calculation.contactSelect.search',
                    component: DemandContactSelectContainer
                },
            ]
        },
        {
            path: 'vypocet-materialu/:projectSlug/:constructionId',
            name: 'calculation.construction',
            component: ConstructionContainer,
            meta: {title: 'Výpočet materiálu'},
        },
        {
            path: 'vyber-vlastnosti/:projectSlug',
            name: 'calculation.constructionSelect',
            component: ConstructionSelectContainer,
            meta: {title: 'Vyběr vlastnosti konstrukce'},
        },
        {
            path: '',
            name: 'calculation.projectSelect',
            component: ProjectSelectContainer,
            meta: {title: 'Výpočet spotřeby materiálu'},
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/calculation/router.js